import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {HOME_MATCH_BASIC_RESIGNATION_TEST_IDS} from "@pg-mono/test-ids";

import {
    HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_TITLE
} from "../../constants/home_match_basic_resignation";
import {useHomeMatchBasicResignationActions} from "../../hooks/use_home_match_basic_resignation_actions";
import type {
    IHomeMatchBasicPreferencesFlowAmplitudeItemContext,
    IHomeMatchBasicPreferencesFlowTrackingContext
} from "../../types/HomeMatchBasicPreferencesFlowTypes";
import {HomeMatchBasicPreferencesFlowResignationDescription} from "./HomeMatchBasicPreferencesFlowResignationDescription";

interface IProps {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    amplitudeItemContext?: IHomeMatchBasicPreferencesFlowAmplitudeItemContext;
    zIndex?: number;
}

export const HomeMatchBasicPreferencesFlowResignationResponsiveModal = (props: IProps) => {
    const {isOpen, isSaving, zIndex} = props;
    const titleId = useId();
    const descriptionId = useId();
    const {isKeepEnabledLoading, isDisableLoading, handleClose, handleKeepEnabled, handleDisable} = useHomeMatchBasicResignationActions(props);

    return (
        <ResponsiveModal
            isOpen={isOpen}
            onClose={handleClose}
            zIndex={zIndex}
            ariaLabelledBy={titleId}
            ariaDescribedBy={descriptionId}
            className={modalStyle}
            overlayClassName={overlayStyle}
            dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.WRAPPER}
        >
            <ResponsiveModal.Header divider={false} className={headerStyle}>
                <div className={headerTextStyle}>
                    <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                        {HOME_MATCH_BASIC_RESIGNATION_TITLE}
                    </Text>
                    <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-secondary)" className={descriptionStyle}>
                        <HomeMatchBasicPreferencesFlowResignationDescription />
                    </Text>
                </div>

                <ResponsiveModal.CloseButton dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.CLOSE_BUTTON} />
            </ResponsiveModal.Header>

            <ResponsiveModal.Footer className={footerStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    className={buttonStyle}
                    disabled={isSaving}
                    isLoading={isKeepEnabledLoading}
                    onClick={handleKeepEnabled}
                    dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.KEEP_ENABLED_BUTTON}
                >
                    {HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT}
                </Button>
                <Button
                    type="button"
                    variant="outlined_secondary"
                    size="medium"
                    fullWidth
                    className={buttonStyle}
                    disabled={isSaving}
                    isLoading={isDisableLoading}
                    onClick={handleDisable}
                    dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.DISABLE_BUTTON}
                >
                    {HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT}
                </Button>
            </ResponsiveModal.Footer>
        </ResponsiveModal>
    );
};

const modalStyle = css({
    md: {
        borderRadius: 2
    }
});

// Opened in place of a previous modal of the registration flow - the backdrop stays fully visible instead of fading in again
const overlayStyle = css({
    animation: "none"
});

const headerStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem",
    px: 2,
    py: 1.5
});

const headerTextStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    flex: "1 1 auto",
    minWidth: 0
});

const descriptionStyle = css({
    lineHeight: "1.8rem",
    md: {
        lineHeight: "2rem"
    }
});

const footerStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 2,
    px: 2,
    pt: 1.5,
    pb: 3
});

const buttonStyle = css({
    height: "auto",
    minHeight: "5.6rem",
    py: 1,
    whiteSpace: "normal",
    textAlign: "center"
});
import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {HOME_MATCH_BASIC_RESIGNATION_TEST_IDS} from "@pg-mono/test-ids";

import {
    HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_TITLE
} from "../../constants/home_match_basic_resignation";
import {useHomeMatchBasicResignationActions} from "../../hooks/use_home_match_basic_resignation_actions";
import type {
    IHomeMatchBasicPreferencesFlowAmplitudeItemContext,
    IHomeMatchBasicPreferencesFlowTrackingContext
} from "../../types/HomeMatchBasicPreferencesFlowTypes";
import {HomeMatchBasicPreferencesFlowResignationDescription} from "./HomeMatchBasicPreferencesFlowResignationDescription";

interface IProps {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    amplitudeItemContext?: IHomeMatchBasicPreferencesFlowAmplitudeItemContext;
    zIndex?: number;
}

export const HomeMatchBasicPreferencesFlowResignationResponsiveModal = (props: IProps) => {
    const {isOpen, isSaving, zIndex} = props;
    const titleId = useId();
    const descriptionId = useId();
    const {isKeepEnabledLoading, isDisableLoading, handleClose, handleKeepEnabled, handleDisable} = useHomeMatchBasicResignationActions(props);

    return (
        <ResponsiveModal
            isOpen={isOpen}
            onClose={handleClose}
            zIndex={zIndex}
            ariaLabelledBy={titleId}
            ariaDescribedBy={descriptionId}
            className={modalStyle}
            overlayClassName={overlayStyle}
            dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.WRAPPER}
        >
            <ResponsiveModal.Header divider={false} className={headerStyle}>
                <div className={headerTextStyle}>
                    <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                        {HOME_MATCH_BASIC_RESIGNATION_TITLE}
                    </Text>
                    <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-secondary)" className={descriptionStyle}>
                        <HomeMatchBasicPreferencesFlowResignationDescription />
                    </Text>
                </div>

                <ResponsiveModal.CloseButton dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.CLOSE_BUTTON} />
            </ResponsiveModal.Header>

            <ResponsiveModal.Footer className={footerStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    className={buttonStyle}
                    disabled={isSaving}
                    isLoading={isKeepEnabledLoading}
                    onClick={handleKeepEnabled}
                    dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.KEEP_ENABLED_BUTTON}
                >
                    {HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT}
                </Button>
                <Button
                    type="button"
                    variant="outlined_secondary"
                    size="medium"
                    fullWidth
                    className={buttonStyle}
                    disabled={isSaving}
                    isLoading={isDisableLoading}
                    onClick={handleDisable}
                    dataTestId={HOME_MATCH_BASIC_RESIGNATION_TEST_IDS.DISABLE_BUTTON}
                >
                    {HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT}
                </Button>
            </ResponsiveModal.Footer>
        </ResponsiveModal>
    );
};

const modalStyle = css({
    md: {
        borderRadius: 2
    }
});

// Opened in place of a previous modal of the registration flow - the backdrop stays fully visible instead of fading in again
const overlayStyle = css({
    animation: "none"
});

const headerStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem",
    px: 2,
    py: 1.5
});

const headerTextStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    flex: "1 1 auto",
    minWidth: 0
});

const descriptionStyle = css({
    lineHeight: "1.8rem",
    md: {
        lineHeight: "2rem"
    }
});

const footerStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 2,
    px: 2,
    pt: 1.5,
    pb: 3
});

const buttonStyle = css({
    height: "auto",
    minHeight: "5.6rem",
    py: 1,
    whiteSpace: "normal",
    textAlign: "center"
});
